import { sseStore } from '@ai/common/src/store/SseStore';
import { DialogMessageRole } from '@ai/common/src/types/chat';
import { intlNumberFormat } from '@ai/common/src/utils/IntlNumberFormat';
import { useCurrentUserTariffPurchaseInfo } from '@hooks/useCurrentUserTariffPurchaseInfo';
import { Stack, Typography } from '@mui/material';
import { tariffPlanPurchaseStore } from '@store/TariffPlanPurchaseStore';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const ActiveTariffRemainings = observer(() => {
  const { tariffPlanPurchases, tariffPlans } = useCurrentUserTariffPurchaseInfo();
  const { t } = useTranslation();
  const { dialogMessageEvent } = sseStore;
  const { loadList } = tariffPlanPurchaseStore;

  useEffect(() => {
    if (!dialogMessageEvent) return;

    const { dialog_mode, dialog_message } = dialogMessageEvent;

    if (
      (dialog_mode === 'expert' || !dialog_mode) &&
      dialog_message.role === DialogMessageRole.ASSISTANT
    ) {
      loadList();
    }
  }, [dialogMessageEvent, loadList]);

  const purchase = tariffPlanPurchases.current;
  const plan = tariffPlans?.find((p) => p.id === purchase?.tariff_plan_id);

  if (!purchase || !plan) return null;

  return (
    <Stack px={2} py={1} gap={1} borderRadius={1} border={'1px solid #26393F'}>
      <Stack>
        <Typography
          fontWeight={500}
          color="white"
          paddingInline={2}
          textAlign={'center'}
          whiteSpace={'nowrap'}
          sx={{
            backgroundColor: (theme) => theme.palette.primary.main,
            borderRadius: '4px',
          }}
        >
          {plan?.name}
        </Typography>
      </Stack>

      <Stack>
        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'end'}>
          <Typography fontSize={12} color="gray" whiteSpace={'nowrap'}>
            {`${t('pricing.ofVoiceResponces')}:`}
          </Typography>

          <Typography>
            {intlNumberFormat(Math.round(purchase.remaining_balance / plan.voice_response_rate))}
          </Typography>
        </Stack>

        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'end'}>
          <Typography fontSize={12} color="gray" whiteSpace={'nowrap'}>
            {`${t('pricing.ofTextResponces')}:`}
          </Typography>

          <Typography>
            {intlNumberFormat(Math.round(purchase.remaining_balance / plan.text_response_rate))}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
});
